module.exports = __webpack_public_path__ + "img/mastercard.dc337432.png";